import httpClient from "../../clients/httpClient";
import { ITrainingVideosResponse } from "../../state/types/training-video";

const BASE = "/api/v1/training-videos";

export const getTrainingVideos = () => {
    return httpClient.get<ITrainingVideosResponse>(BASE);
};

// Idempotent — a repeat call keeps the original watched_at. Returns the same
// payload shape as the index, so the response is the new state for both surfaces.
export const markTrainingVideoWatched = (id: number) => {
    return httpClient.post<ITrainingVideosResponse>(`${BASE}/${id}/watch`, {});
};
